import React from 'react';
import PropTypes from 'prop-types';

const RightArrowAlt = ({
  width = '12px',
  height = '8px',
  color = '#000',
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 12 8"
      className={className}>
      <path
        fill={color}
        d="M11.8291896,3.59831183 L8.26041636,0.157451613 C8.04267658,-0.052483871 7.68954647,-0.052483871 7.47180669,0.157451613 C7.2540223,0.367430108 7.2540223,0.707817204 7.47180669,0.917795699 L10.0886543,3.44084946 L0.557620818,3.44084946 C0.249680297,3.44084946 0,3.68158065 0,3.97848387 C0,4.27534409 0.249680297,4.51611828 0.557620818,4.51611828 L10.0886543,4.51611828 L7.47189591,7.03917204 C7.25411152,7.24915054 7.25411152,7.58953763 7.47189591,7.79951613 C7.58074349,7.90441935 7.72349442,7.95697849 7.86620074,7.95697849 C8.00890706,7.95697849 8.15161338,7.90441935 8.26050558,7.79951613 L11.8291896,4.35865591 C12.046974,4.14867742 12.046974,3.80829032 11.8291896,3.59831183 Z"
      />
    </svg>
  );
};

RightArrowAlt.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
};

export default RightArrowAlt;
